export const projectDetailWithEmployeesReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "GET_PROJECT_DETAIL_WITH_EMPLOYEES":
      return {
        projectDetailWithEmployees: action.payload,
      };
    default:
      return state;
  }
};
